import { z } from 'zod'

/**
 * Where a couple came from (docs/ad-attribution.spec.md). Mirrors
 * `SourceChannel` in the Prisma schema. Google Ads is broken down by campaign,
 * and a listing site is shown by its own name.
 */
export const SOURCE_CHANNELS = ['google_ads', 'meta_ads', 'listing', 'website', 'social', 'phone', 'referral', 'unknown'] as const

export const sourceChannelSchema = z.enum(SOURCE_CHANNELS)

export type SourceChannel = z.infer<typeof sourceChannelSchema>

/**
 * What each is called on screen. `referral` is word of mouth: GoHighLevel's own
 * "Referral" means another website linked to the venue's, which is different.
 */
export const SOURCE_CHANNEL_LABELS: Readonly<Record<SourceChannel, string>> = {
  google_ads: 'Google Ads',
  meta_ads: 'Meta Ads',
  listing: 'Listing site',
  website: 'Website',
  social: 'Social',
  phone: 'Phone',
  referral: 'Word of mouth',
  unknown: 'Unknown',
}

/** What a venue can say one of its lead source names means: anything but Unknown, which is what no answer means. */
export const MAPPABLE_CHANNELS = ['google_ads', 'meta_ads', 'listing', 'website', 'social', 'phone', 'referral'] as const satisfies readonly SourceChannel[]

export const mappableChannelSchema = z.enum(MAPPABLE_CHANNELS)

export type MappableChannel = z.infer<typeof mappableChannelSchema>
